import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import styles from './AdminLayout.module.css';

const AdminLayout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className={styles.adminLayout}>
            <AdminHeader onMenuClick={ () => setSidebarOpen(!sidebarOpen) } />  
            <div className={styles.mainContainer}>
                <div className={`adminSidebar${sidebarOpen ? ' open' : ''}`}>
                    <AdminSidebar isOpen={sidebarOpen} onClose={ () => setSidebarOpen(false)} />
                </div>
                {sidebarOpen && (
                    <div className={styles.overlay} onClick={() => setSidebarOpen(false)} />
                )}
                <main className={`${styles.mainContent} ${sidebarOpen ? styles.sidebarOpen : ''}`}>
                    {children}
                </main>
            </div>
        </div>
    )
}

export default AdminLayout;